import { Contributor } from "./Show";
import type { PagyMetadata } from "@/components/pagination/PaginationControls";
import PaginationControls from "@/components/pagination/PaginationControls";
import PageHeader from "@/components/PageHeader";
import DataTable, { DataTableColumn } from "@/components/DataTable";
import { PageWithLayout, wideLayout } from "@/components/Layout";

interface IndexProps {
  contributors: Contributor[];
  pagy: PagyMetadata;
}

const columns: DataTableColumn<Contributor>[] = [
  {
    label: "Name",
    minWidth: "min-w-48",
    cellClassName: "font-medium",
    render: (contributor) => contributor.full_name,
  },
  {
    label: "PRO",
    minWidth: "min-w-32",
    cellClassName: "font-light",
    render: (contributor) => contributor.pro_affiliation || "—",
  },
  {
    label: "IPI/CAE Number",
    minWidth: "min-w-40",
    cellClassName: "font-light",
    render: (contributor) => contributor.ipi_cae_number || "—",
  },
  {
    label: "NRO",
    minWidth: "min-w-32",
    cellClassName: "font-light",
    render: (contributor) => contributor.nro_affiliation || "—",
  },
  {
    label: "NRO Number",
    minWidth: "min-w-40",
    cellClassName: "font-light",
    render: (contributor) => contributor.nro_number || "—",
  },
];

const Index: PageWithLayout<IndexProps> = ({ contributors, pagy }) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-10">
      <PageHeader
        title="All contributors"
        primaryAction={{ href: "/contributors/new", text: "New Contributor" }}
      />
      <div className="flex w-full flex-col items-start justify-start gap-5">
        <DataTable
          columns={columns}
          rows={contributors}
          rowKey={(contributor) => contributor.id}
          rowHref={(contributor) => `/contributors/${contributor.id}`}
        />
        <PaginationControls {...pagy} />
      </div>
    </div>
  );
};

Index.layout = wideLayout;

export default Index;
